import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Auth.css";

function SignIn() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const res = await fetch("http://localhost:5000/api/users", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (res.ok) {
        setMessage("✅ Sign in successful! Welcome, " + data.name);
        setFormData({ name: "", email: "", password: "" });
      } else {
        setMessage("❌ " + data.message);
      }
    } catch (err) {
      console.error("Error:", err);
      setMessage("⚠️ Server connection error.");
    }
  };

  return (
    <div className="auth-container">
      <h2>Sign In</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          required
        />
        <button type="submit">Sign In</button>
      </form>

      {message && <p className="response-message">{message}</p>}

      <p>
        Already have an account?{" "}
        <Link to="/login" className="switch-link">
          Login here
        </Link>
      </p>
    </div>
  );
}

export default SignIn;

